<div>
    <div class="flex align-items-center justify-content-center mt-3">
        <span class="p-input-icon-left">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt1.filterGlobal($any($event.target).value, 'contains')"
                placeholder="Search" class=" p-inputtext-sm" />
        </span>
    </div>
&nbsp;
    <p-table #dt1 [value]="result.paymentTerms" styleClass="p-datatable-striped" [tableStyle]="{'min-width': '50rem'}"
    [rowsPerPageOptions]="[5, 10]" [globalFilterFields]="['termsCode', 'discount', 'netDue']" [paginator]="true" [rows]="5" [scrollable]="true" scrollHeight="350px"
        responsiveLayout="scroll" class="w-full m-5" (onRowSelect)="SelectOption($event)">
       
        <ng-template pTemplate="header">
            <tr>
                <th></th>
                <th>Code</th>
                <th>Discount</th>
                <th>Conditional Discount</th>
                <th>Net Due</th>
                <th>Description</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-PaymentTerms>
            <tr (click)="SelectOption(PaymentTerms)"> 
                <td>
                    <p-tableRadioButton [value]="PaymentTerms"></p-tableRadioButton> 
                </td>
                <td>{{PaymentTerms.termsCode}}</td>
                <td>{{PaymentTerms.discount}}</td>
                <td>{{PaymentTerms.conditionalDiscount}}</td>
                <td>{{PaymentTerms.netDue}}</td>
                <td>{{PaymentTerms.paymentTermsDescription}}</td>
            </tr>
        </ng-template>
    </p-table>
</div>